import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { DOM } from '@antv/l7-utils';
import { Control, PositionType } from "./baseControl";
export { Logo };
var Logo = /*#__PURE__*/function (_Control) {
  _inherits(Logo, _Control);
  var _super = _createSuper(Logo);
  function Logo() {
    _classCallCheck(this, Logo);
    return _super.apply(this, arguments);
  }
  _createClass(Logo, [{
    key: "getDefault",
    value: function getDefault() {
      return {
        position: PositionType.BOTTOMLEFT,
        name: 'logo',
        href: 'https://l7.antv.antgroup.com/',
        img: 'https://gw.alipayobjects.com/mdn/rms_816329/afts/img/A*GRb1TKp4HcMAAAAAAAAAAAAAARQnAQ'
      };
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      var container = DOM.create('div', 'l7-control-logo');
      this.setLogoContent(container);
      return container;
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      return null;
    }
  }, {
    key: "setOptions",
    value: function setOptions(option) {
      _get(_getPrototypeOf(Logo.prototype), "setOptions", this).call(this, option);
      if (this.checkUpdateOption(option, ['img', 'href'])) {
        DOM.clearChildren(this.container);
        this.setLogoContent(this.container);
      }
    }
  }, {
    key: "setLogoContent",
    value: function setLogoContent(container) {
      var _this$controlOption = this.controlOption,
        href = _this$controlOption.href,
        img = _this$controlOption.img;
      var imgDOM = DOM.create('img');
      imgDOM.setAttribute('src', img);
      imgDOM.setAttribute('aria-label', 'AntV logo');
      DOM.setUnDraggable(imgDOM);
      if (href) {
        var anchorDOM = DOM.create('a', 'l7-control-logo-link');
        anchorDOM.target = '_blank';
        anchorDOM.href = href;
        anchorDOM.rel = 'noopener nofollow';
        anchorDOM.setAttribute('rel', 'noopener nofollow');
        anchorDOM.appendChild(imgDOM);
        container.appendChild(anchorDOM);
      } else {
        container.appendChild(imgDOM);
      }
    }
  }]);
  return Logo;
}(Control);
export { Logo as default };